<!-- 商品分类 -->

<template>
    <div class="classify">
        <div class="tableConBox">
            <div class="tableTem">
                <div class="HSpace1"></div>
                <div class="searchBox flex flex-align-center">
                    <div class="searchCon clearfix">
                        <!--<div class="left search flex flex-align-center">-->
                            <!--<input type="text" class="left" placeholder="请输入姓名或相关信息">-->
                            <!--<i class="el-icon-search"></i>-->
                        <!--</div>-->
                    </div>
                </div>
                <div class="HSpace2"></div>
                <div class="tableBox">
                    <div class="tableBoxScroll">
                        <table class="titleTable">
                            <tr>
                                <th>商品分类</th>
                                <th>操作</th>
                            </tr>
                        </table>
                        <div class="scrollBox">
                            <div class="scroll">
                               <div class="type_parent">
                                    <div class="type_title clearfix">
                                        <span class="left type_title_name flex flex-align-center">商品</span>
                                        <span class="right parent_default flex flex-align-center flex-pack-center">
                                            <i class=" iconfont icon-icon02" title="添加" @click="addClassify(false)"></i>
                                        </span>
                                    </div>
                                    <!--  -->
                                        <div class="sys-net-cost">
                                            <span>{{systemData[0].name}}</span>
                                        </div>
                                    <!--  -->
                                    <div class="type_parent_item type_active" v-for="(item,ind) in typeData" :style="{height:(item.isOpen&&btn?((item.children.length+1)*9+'%'):'9%')}">
                                        <div class="type_parent_text clearfix" :style="{height:(item.isOpen&&btn?(100/(item.children.length+1)+'%'):'100%')}">
                                            <div class="left type_parent_text_left flex flex-align-center" @click="handle(item,ind)">
                                                <i class="i" :class="{
                                                    'el-icon-caret-right':item.children.length  && (!item.isOpen||!btn),
                                                    'el-icon-caret-bottom':item.children.length && (!item.isOpen||btn)}"
                                                ></i>
                                                <span class="parent_default type_name" v-text="item.name"></span>
                                            </div>
                                            <div class="right ss flex flex-align-center flex-pack-center">
                                               <!-- <span style="color: #9cda71;" @click="sorting(true,item,ind)">上移</span>
                                               <span style="color: #f76260;" @click="sorting(false,item,ind)">下移</span> -->
                                            </div>
                                            <span class="right type_parent_text_right flex flex-align-center flex-pack-center" >
                                                <i class=" iconfont icon-icon02" title="添加" @click="addClassify(item.id)"></i>
                                                <i class="iconfont icon-bianji" title="修改" @click="upClassify(item,false)"></i>
                                                <i class=" iconfont icon-icon1460188478041" title="删除" @click="delClassify(item,false)"></i>
                                            </span>
                                        </div>
                                        <div class="type_child" v-if="item.isOpen && btn" :style="{height:(100 - 100/(item.children.length+1)+'%')}">
                                            <div class="type_child_item" v-for="(oitem,oInd) in item.children" :style="{height:(100/(item.children.length)+'%')}">
                                                <div class="type_child_left left flex flex-align-center">
                                                    <span v-text="oitem.name" class="left"></span>
                                                    <span class="right"></span>
                                                </div>
                                                <span style="padding-right:20px">
                                                    <div class="right ss flex flex-align-center flex-pack-center">
                                                    <!-- <span style="color: #9cda71;padding-right:5px;font-size:14px;cursor:pointer;" @click="sortingChild(true,oitem,oInd,item)">上移</span>
                                                    <span style="color: #f76260;padding-right:5px;font-size:14px;cursor:pointer;" @click="sortingChild(false,oitem,oInd,item)">下移</span> -->
                                                </div>
                                                <!-- <span class="type_child_right right flex flex-align-center flex-pack-center"> -->
                                                <span class="right type_parent_text_right flex flex-align-center flex-pack-center">
                                                    <!-- <i class=" iconfont icon-icon02" title="添加" @click="addClassify(item.id)"></i> -->
                                                    <i class="iconfont icon-bianji" title="修改" style="padding-right:10px" @click="upClassify(item,oitem)"></i>
                                                    <i class=" iconfont icon-icon1460188478041" style="padding-right:10px" title="删除" @click="delClassify(item,oitem)"></i>
                                                </span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                               </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 分页器 -->
                <!-- <div class="pager flex flex-align-center">
                    <div class="pagerCon clearfix">
                        <div class="pagerBtnBox right">
                            <div class="pagerBtn">
                                <span class="prev flex flex-align-center flex-pack-center left"><i class="el-icon-arrow-left"></i></span>
                                <span class="curPageNumber flex flex-align-center flex-pack-center left">1</span>
                                <span class="next flex flex-align-center flex-pack-center left havePage"><i class="el-icon-arrow-right"></i></span>
                            </div>
                        </div>
                        <div class="curPage flex flex-align-center right">第 1 / 9 条</div>
                        <div class="totalPage flex flex-align-center right">共100条</div>
                    </div>
                </div> -->
            </div>
        </div>
        <el-dialog
            :title="typeName"
            :visible.sync="addJobVisible"
            size="tiny">
            <div>
                <div class="msgBox clearfix">
                    <div class="left msgItem clearfix">
                        <span class="left itemName"><i>*</i>名称</span>
                        <input type="text" class="left itemInput" v-model="obj.name" placeholder="请输入名称">
                    </div>
                    <div class="left msgItem clearfix">
                        <span class="left itemName"><i>*</i>排序</span>
                        <input type="text" class="left itemInput" v-model="obj.sequence" placeholder="请输入">
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <button type="button" @click="addJobVisible=false" class="cancel">取消</button>
                <button type="button" @click="addJob" class="save">保存</button>
            </span>
        </el-dialog>
    </div>
</template>

<script type="text/javascript">
    import {url} from '@/router/url.js';
    export default{
    	data () {
    		return {
                addJobVisible: false,
                btn:false,//分类下拉三角样式
                typeData:[],
                obj: {
                    name:'',
                    id:'',
                    arId:''
                },
                typeBtn: '',
                typeName: '',
                addJobBtn: true,
                systemData:[]
    		}
    	},
        methods: {
            //添加或者修改分类
            addJob(){
                if(!this.obj.name){
                    this.$message({
                        message: '分类名称有误',
                        customClass: 'error'
                    })
                    return;
                }
                this.$set(this.obj,"name",this.obj.name.replace(/\s*/g,""));
                if(this.typeBtn == 1){
                    //添加父类
                    let data = {
                        "id"      : this.$uuid.create(1).hex,
                        "sequence":-1,
                        "name"    : this.obj.name,
                        "sequence": this.obj.sequence,
                        "storeId" : this.$route.params.id,
                        "parentId": ''
                    }
                    if(!this.addJobBtn){
                        return;
                    }
                    this.addJobBtn = false;
                    this.$http.put('/product-types',data).then((res)=>{
                        this.getDataList();
                        this.addJobVisible = false ;
                        this.addJobBtn = true;
                    }).catch(()=>{
                        this.addJobBtn = true;
                    })
                }else if(this.typeBtn == 2){
                    //添加子类
                    let data = {
                        "id"      : this.$uuid.create(1).hex,
                        "name"    : this.obj.name,
                        "sequence": this.obj.sequence,
                        "storeId" : this.$route.params.id,
                        "parentId": this.obj.id
                    }
                    if(!this.addJobBtn){
                        return;
                    }
                    this.addJobBtn = false;
                    this.$http.put('/product-types',data).then((res)=>{
                        this.getDataList();
                        this.addJobVisible = false ;
                        this.addJobBtn = true;
                    }).catch(()=>{
                        this.addJobBtn = true;
                    })
                }else if(this.typeBtn == 3){
                    //、、修改父类
                    let data = {
                        "id"      : this.obj.id,
                        "sequence": this.obj.sequence,
                        "name"    : this.obj.name,
                        "storeId" : this.$route.params.id,
                        "parentId": ''
                    }
                    if(!this.addJobBtn){
                        return;
                    }
                    this.addJobBtn = false;
                    this.$http.put('/product-types',data).then((res)=>{
                        this.getDataList();
                        this.addJobVisible = false ;
                        this.addJobBtn = true;
                    }).catch(()=>{
                        this.addJobBtn = true;
                    })
                }else if(this.typeBtn == 4){
                     //、、修改子类
                    let data = {
                        "id"      : this.obj.id,
                        "name"    : this.obj.name,
                        "sequence": this.obj.sequence,
                        "storeId" : this.$route.params.id,
                        "parentId": this.obj.arId
                    }
                    if(!this.addJobBtn){
                        return;
                    }
                    this.addJobBtn = false;
                    this.$http.put('/product-types',data).then((res)=>{
                        this.getDataList();
                        this.addJobVisible = false ;
                        this.addJobBtn = true;
                    }).catch(()=>{
                        this.addJobBtn = true;
                    })
                }
            },
            sortingChild(boo,item,ind,pItem){
                let list = [];
                if( boo ){
                    //上移
                    for (let i = 0, len = pItem.children.length; i < len; i++) {
                        if(ind==0){
                            this.$message({
                                message: '已经是第一项了',
                                customClass: 'error'
                            })
                            return;
                        }
                        let body = {
                            "productTypeId":pItem.children[i].id,
                            "sequence":i
                        };
                        list.push(body)
                        if(ind == i){
                            list[i].sequence = i-1;
                            list[i-1].sequence = i;
                        }
                    }
                }else{
                    if(ind==pItem.children.length-1){
                        this.$message({
                            message: '已经是最后一项了',
                            customClass: 'error'
                        })
                        return;
                    }
                    let num=-1;
                    for (let i = 0, len = pItem.children.length; i < len; i++) {
                        let body = {
                            "productTypeId":pItem.children[i].id,
                            "sequence":i
                        };
                        list.push(body)
                        if(ind == i){
                            list[i].sequence = i+1;
                            num = i+1;
                        }
                        if(num == i ){
                            list[num].sequence = i-1;
                        }
                    }
                }
                this.$http.put('/product-sequence',{"products":list}).then((res)=>{
                    this.getDataList();
                }).catch((err) => {
                });
            },
            //排序
            sorting(boo,item,ind){
                let list = [];
                if( boo ){
                    //上移
                    for (let i = 0, len = this.typeData.length; i < len; i++) {
                        if(ind==0){
                            this.$message({
                                message: '已经是第一项了',
                                customClass: 'error'
                            })
                            return;
                        }
                        let body = {
                            "productTypeId":this.typeData[i].id,
                            "sequence":i
                        };
                        list.push(body)
                        if(ind == i){
                            list[i].sequence = i-1;
                            list[i-1].sequence = i;
                        }
                    }
                }else{
                    if(ind==this.typeData.length-1){
                        this.$message({
                            message: '已经是最后一项了',
                            customClass: 'error'
                        })
                        return;
                    }
                    let num=-1;
                    for (let i = 0, len = this.typeData.length; i < len; i++) {
                        let body = {
                            "productTypeId":this.typeData[i].id,
                            "sequence":i
                        };
                        list.push(body)
                        if(ind == i){
                            list[i].sequence = i+1;
                            num = i+1;
                        }
                        if(num == i ){
                            list[num].sequence = i-1;
                        }
                    }
                }
                this.$http.put('/product-sequence',{"products":list}).then((res)=>{
                    this.getDataList();
                }).catch((err) => {
                });
            },
            getDataList(){
                this.$http.get('/product-types?storeId='+this.$route.params.id+'&parentId='+'').then((res)=>{
                    let body = res.data.data;
                    this.systemData = res.data.systemData;

                    let newArr = []; 
                    for (let i = 0, len = body.length; i < len; i++) {
                        if ( !body[i].parent ) {
                            body[i].isOpen = false;
                            newArr.push(body[i]);
                            newArr[newArr.length-1].children = [];
                            for (let j = 0, len = body.length; j < len; j++) {
                                if ( body[j].parent&&body[i].id==body[j].parent.id) {
                                    newArr[newArr.length-1].children.push(body[j]);
                                }
                            }
                        }
                    }
                    let sequenceArr = [];//排序数组
                    
                    for (let i = 0, len = newArr.length; i < len; i++){
                        for (let j = 0, len = newArr.length; j < len; j++){
                            if(newArr[j].sequence == i){
                                sequenceArr.push(newArr[j]);
                            }
                        }
                    }
                    // 
                    for(let i=0;i<sequenceArr.length;i++){
                        if(sequenceArr.children && sequenceArr.children.length){
                            let tempArr = JSON.parse(JSON.stringify(sequenceArr.children));
                            tempArr.sort((a,b)=>{
                                return a.sequence - b.sequence;
                            });
                            sequenceArr.children = tempArr;
                        }
                    }
                    // 
                    this.typeData = sequenceArr;
                }).catch((err) => {
                });
            },
            addClassify(id){
                //添加分类
                this.typeName = "添加分类"
                this.obj = {
                    name:'',
                    id:'',
                    arId:''
                };
                this.addJobVisible = true ;
                this.obj.id = id?id:'';
                this.typeBtn = id?2:1;
            },
            upClassify(item,oitem){
                //修改分类
                this.typeName = "修改分类"
                this.obj = {
                    name:oitem ? oitem.name : item.name,
                    id: oitem ? oitem.id :　item.id,
                    sequence: oitem ? oitem.sequence :　item.sequence,
                    arId:item.id
                };
                oitem ? '':this.obj.sequence = item.sequence
                this.addJobVisible = true ;
                this.typeBtn = oitem ? 4:3;
            },
            delClassify(item,oitem){
                this.$confirm(`是否删除 ${ oitem ? (oitem.name+' 分类?'):item.name+' 分类及该类下所有子分类?'}`, '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                    //删除分类
                    this.$http.delete('/product-types?id='+(oitem?oitem.id:item.id)).then((res)=>{
                        this.getDataList();
                    })
                }).catch(() => {});

            },
            handle(item,ind){
                if(this.typeData[ind].isOpen){
                    this.btn = !this.btn;
                }else{
                    this.btn = true ;
                }
                for(var i = 0,len = this.typeData.length; i < len;i++){
                   this.typeData[i].isOpen = false;
                }
                this.typeData[ind].isOpen  = true;
            }
        },
        activated: function () {
            //就怕sequence会大于数组的长度
            this.$http.get('/product-types?storeId='+this.$route.params.id+'&parentId='+'').then((res)=>{
                console.log(res.data)
                let body = res.data.data;
                this.systemData = res.data.systemData;
                let newArr = []; 
                for (let i = 0, len = body.length; i < len; i++) {
                    if ( !body[i].parent ) {
                        body[i].isOpen = false;
                        newArr.push(body[i]);
                        newArr[newArr.length-1].children = [];
                        for (let j = 0, len = body.length; j < len; j++) {
                            if ( body[j].parent&&body[i].id==body[j].parent.id) {
                                newArr[newArr.length-1].children.push(body[j]);
                            }
                        }
                    }
                }
                let list = [];
                for (let i = 0, len = newArr.length; i < len; i++) {
                    let bodys = {
                        "productTypeId":newArr[i].id,
                        "sequence":i
                    };
                    list.push(bodys)
                }
                if(!list.length){
                    return;
                }
                this.$http.put('/product-sequence',{"products":list}).then((res)=>{
                    this.getDataList();
                }).catch((err) => {
                });
            }).catch((err) => {
            });
        }
    }
</script>
<style lang="scss">
    @import '../../../../static/css/common.scss';
    @import '../../tableTemplate/tableTem.scss';
    @import '../../tableTemplate/el-dialog.scss';
	@import "classify.scss";
</style>



// WEBPACK FOOTER //
// classify.vue?768b13b4